import CardSimple from './card-medium'

export default CardSimple
